import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import atomize from "@quarkly/atomize";
var Wrapper = atomize.div(_templateObject());

var empty = function empty() {
  return null;
};

var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      size = _ref.size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "1em" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "1em" : _ref$height,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["icon", "size", "width", "height", "children"]);

  var Icon = typeof icon === "function" ? icon : empty;
  return React.createElement(Wrapper, _extends({}, rest, {
    "font-size": size,
    width: width,
    height: height
  }), React.createElement(Icon, {
    className: "icon"
  }));
};

Icon.defaultProps = {
  size: "24px"
};
export default Icon;